import { render } from "./CommentsModal.vue?vue&type=template&id=e38a85ca&ts=true&lang=pug"
import script from "./CommentsModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./CommentsModal.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__